// extracted by mini-css-extract-plugin
export default {"root":"FaceList__root--2wFtd","tooltip":"FaceList__tooltip--3rRTS"};